import { matchesAcronym } from './acronymMatch';
import { normalizeQuery } from './normalizeQuery';

/** Letter-only acronym (2–6), aligned with backend entity search — not phone digits. */
export const isEntityAcronymQuery = (query: string): boolean => {
  const normalized = normalizeQuery(query);
  return /^[a-z]{2,6}$/.test(normalized);
};

export type AcronymRankableHit = {
  primary: string;
};

/**
 * Stable sort: hits whose primary matches the query as acronym first.
 * No-op when query is not an entity acronym.
 */
export const rankHitsByAcronym = <T extends AcronymRankableHit>(
  hits: T[],
  query: string,
): T[] => {
  if (!isEntityAcronymQuery(query) || hits.length < 2) return hits;

  return hits
    .map((hit, index) => ({
      hit,
      index,
      acronym: matchesAcronym(query, [hit.primary]),
    }))
    .sort((a, b) => {
      if (a.acronym !== b.acronym) return a.acronym ? -1 : 1;
      return a.index - b.index;
    })
    .map((row) => row.hit);
};
